import React, { useState } from "react";
import { Layout, theme } from "antd";
import CustomHeader from "./CustomHeader";
import CustomFooter from "./CustomFooter";

const { Content } = Layout;

function Main({
	children,
	showFooter = true,
	fullHeight = true,
}: {
	children?: React.ReactNode;
	showFooter?: boolean;
	fullHeight?: boolean;
}) {
	const [collapsed, setCollapsed] = useState(false);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [query, setQuery] = useState("");

	const {
		token: { colorBgBase, colorBgContainer },
	} = theme.useToken();

	return (
		<div
			style={{
				background: "#FBFBFB",
			}}>
			{/* <CustomSider collapsed={collapsed} setCollapsed={setCollapsed} query={query} /> */}
			<Layout
				style={{
					margin: "0 auto",
				}}>
				<CustomHeader
					onSearch={(value: any) => setQuery(value)}
					collapsed={collapsed}
					setCollapsed={setCollapsed}
				/>
				<Content
					style={{
						margin: "24px 0",
						padding: "0 24px",
						overflow: "initial",
						minHeight: fullHeight ? "calc(100svh - 94px)" : "100%",
					}}>
					<div>{children}</div>
				</Content>
				{showFooter && <CustomFooter />}
			</Layout>
		</div>
	);
}

export default Main;
